import { ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';

export function nameValidator(): ValidatorFn {
  return (control: AbstractControl<string>): ValidationErrors | null => {
    const { value } = control;

    if (!value) return null;

    const nameRegex = /^[\p{L} '-]{1,50}$/gu;

    if (nameRegex.test(value)) return null;

    return {
      name: true,
    };
  };
}
